// extracted by mini-css-extract-plugin
export default {"row":"styles_row__jVD-9","grayRow":"styles_grayRow__rp9Jv"};